import { render, staticRenderFns } from "./Security.vue?vue&type=template&id=8cdf8ffe&scoped=true&"
var script = {}
import style0 from "./Security.vue?vue&type=style&index=0&id=8cdf8ffe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cdf8ffe",
  null
  
)

export default component.exports